/*
 * @Description: 保养建议
 * @Author: webJ
 */
import ajax from '../http/ajax'

/**
 * 获取保养建议页列表
 * @param {*} params 参数
 */
export const getAdviceList = params => {
    return ajax.get('getAdviceList', params)
}

/**
 * 获取保养商品规格信息
 * @param {*} params 参数
 */
export const getGoodsSkuInfo = params => {
    return ajax.get('getGoodsSkuInfo', params)
}

/**
 * 查询某个商品的数据
 * @param {*} params 参数
 */
export const getAdviceGoodsData = params => {
    return ajax.get('getAdviceGoodsData', params)
}

/**
 * 获取可服务选择的数据
 * @param {*} params 参数
 */
export const getAdviceServicesList = params => {
    return ajax.get('getAdviceServicesList', params)
}

/**
 * 获取可服务选择的数据
 * @param {*} params 参数
 */
export const getAdviceGoodsList = params => {
    return ajax.get('getAdviceGoodsList', params)
}
